export const getBloodPressureClassificationColor = (classificationColor?: string) => {
  if (!classificationColor) return 'var(--mantine-color-gray-5)';
  if (classificationColor === 'orange') return 'var(--mantine-color-peach-7)';
  if (classificationColor === 'red') return 'var(--mantine-color-red-5)';
  if (classificationColor === 'green') return 'var(--mantine-color-turquoise-5)';
  return 'var(--mantine-color-gray-5)';
};

export const BloodPressureGuidelinesKeys = {
  ESC_2018: 'ESC_2018',
  ESC_2024: 'ESC_2024',
};
